/** Settings that save the moment they change say so: anything that saved calls this and the toast in App shows "Saved". */
export const SAVED_EVENT = 'vc-saved'
export const announceSaved = (): void => { window.dispatchEvent(new Event(SAVED_EVENT)) }
